import React, { useEffect, useRef, useState } from "react";
import TopicFrame from "../../../components/TopicFrame/TopicFrame";
import lennaImage from "../../../assets/images/Lenna_(test_image).png";

const SigaPage = () => {
  const canvasRef = useRef(null);
  const binarizedCanvasRef = useRef(null);
  const [threshold, setThreshold] = useState(200);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const binarizedCanvas = binarizedCanvasRef.current;
    
    if (!canvas || !binarizedCanvas) return;
    
    const ctx = canvas.getContext("2d");
    const binCtx = binarizedCanvas.getContext("2d");

    const img = new Image();
    img.onload = () => {
      // Set canvas sizes according to the image
      canvas.width = img.width;
      canvas.height = img.height;
      binarizedCanvas.width = img.width;
      binarizedCanvas.height = img.height;

      ctx.drawImage(img, 0, 0);
      setImageLoaded(true);
    };
    img.src = lennaImage; // Using the imported image
  }, []);

  useEffect(() => {
    if (!imageLoaded) return;
    
    const canvas = canvasRef.current;
    const binarizedCanvas = binarizedCanvasRef.current;
    const ctx = canvas.getContext("2d");
    const binCtx = binarizedCanvas.getContext("2d");

    updateBinarizedImage(ctx, binCtx, canvas.width, canvas.height, threshold);
  }, [threshold, imageLoaded]);

  const updateBinarizedImage = (ctx, binCtx, width, height, threshold) => {
    const imageData = ctx.getImageData(0, 0, width, height);
    binCtx.putImageData(binarizeImage(imageData, threshold), 0, 0);
  };

  const binarizeImage = (imageData, threshold) => {
    const data = imageData.data;
    for (let i = 0; i < data.length; i += 4) {
      const brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
      const color = brightness < threshold ? 0 : 255;
      data[i] = color;     // Red
      data[i + 1] = color; // Green
      data[i + 2] = color; // Blue
    }
    return imageData;
  };

  const handleThresholdChange = (e) => {
    setThreshold(parseInt(e.target.value, 10));
  };

  return (
    <>
      <TopicFrame topicType="bildverarbeitung" entryNumber={0}>
        <div className="container mx-auto p-4">
          <div className="outerContainer" id="Binarisierung">
            <label htmlFor="thresholdSlider">Binarisierungsschwellenwert:&nbsp;<span id="thresholdValue">{threshold}</span></label>
            <div className="slider-container">
                <div className="slider-track"></div>
                <input 
                  type="range" 
                  id="thresholdSlider" 
                  className="slider" 
                  data-slider="start" 
                  min="1"
                  max="255" 
                  value={threshold} 
                  onChange={handleThresholdChange}
                  step="1" 
                />
            </div>
          </div>
          <div className="outerContainer">
            <div className="twoCanvas">
              <div className="canvasBorder">
                <canvas ref={canvasRef} id="canvas"></canvas>
              </div>
              <div className="canvasBorder">
                <canvas ref={binarizedCanvasRef} id="binarizedCanvas"></canvas>
              </div>
            </div>
          </div>
        </div>
      </TopicFrame>
    </>
  );
};

export default SigaPage;